import { useEffect } from 'react';
import { FormControl, InputLabel, Grid, MenuItem, Select } from '@mui/material';
import { ApplicationSearchParams } from '@shared/api';
import { Input, useDebounce } from '@shared';
import { CustomDatePicker } from './CustomDatePicker';

const STATUSES = ['Draft', 'IppCreditAuthority', 'InProgress', 'Complete', 'Rejected'];

interface Props {
  onSubmit(search: ApplicationSearchParams): void;
  filterCriteria: ApplicationSearchParams;
  onFilterChange: (name: string, value: Date | string | null) => void;
}

export const ApplicationSearchForm = (props: Props) => {
  const debouncedFilterCriteria = useDebounce(props.filterCriteria);
  useEffect(() => {
    props.onSubmit(debouncedFilterCriteria);
  }, [debouncedFilterCriteria]);

  return (
    <form>
      <Grid container>
        <Grid item xs={12}>
          <Input
            name='ApplicationName'
            label='Application Ref №'
            value={props.filterCriteria.ApplicationName || ''}
            onChange={(e) => props.onFilterChange('ApplicationName', e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            name='Passport'
            label='Passport / ID Card Number'
            value={props.filterCriteria.Passport || ''}
            onChange={(e) => props.onFilterChange('Passport', e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <InputLabel>Status</InputLabel>
            <Select
              variant='standard'
              name='Status'
              label='Status'
              fullWidth
              value={props.filterCriteria.status || ''}
              onChange={(e) => props.onFilterChange('status', e.target.value)}
            >
              {props.filterCriteria.status ? (
                <MenuItem>
                  <em>Clear</em>
                </MenuItem>
              ) : null}
              {STATUSES.map((item, idx) => (
                <MenuItem key={idx} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <CustomDatePicker
            name='ModifiedOn'
            label='Last Updated'
            inputFormat='dd/MM/yyyy'
            fullWidth
            validate
            value={props.filterCriteria.ModifiedOn || null}
            onChange={(value) => props.onFilterChange('ModifiedOn', value)}
          />
        </Grid>
      </Grid>
    </form>
  );
};
